import { axios } from '@/utils/request'

const api = {
  source: '/enterprise/source',
  company: '/enterprise/management'
}

export function getSlectCombox (parameter) {
  return axios({
    url: api.company + '/selectCombox',
    method: 'get',
    params: parameter
  })
}

export function getSourceList (parameter) {
  return axios({
    url: api.source + '/querySource',
    method: 'get',
    params: parameter
  })
}

export function saveSource (parameter) {
  return axios({
    url: api.source+(parameter.sourceId == 0 ? '/addSource' : '/editSource'),
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

export function delSource (parameter) {
  return axios({
    url: api.source + '/deleteSource',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

//禁用
export function forbiddenSource (parameter) {
  return axios({
    url: api.source + '/forbiddenSource',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

//启动
export function enableSource (parameter) {
  return axios({
    url: api.source + '/enableSource',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

export const sourceExport = api.source + '/export'
